<!--
 * @Author: 朱海良 421973703@qq.com
 * @Date: 2023-10-31 09:58:01
 * @LastEditors: 朱海良 421973703@qq.com
 * @LastEditTime: 2023-10-31 12:22:47
 * @FilePath: \XC_ZHW\src\components\foot.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="inscribe">
    <div class="hotline">
      本服务由谷城县供水总公司提供<br />24小时便民服务热线：0710-7246327
      <br />
      <a href="https://beian.miit.gov.cn">鄂ICP备2023019298号</a>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Head extends Vue {}
</script>
<style scoped lang="less">
.inscribe {
  margin: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  // position: absolute;
  // bottom: 50px;
  // left: 50%;
  // transform: translateX(-50%);
  .seal {
    width: 38px;
    height: 48px;
    background: url("../../public/img/logo@2x.png") no-repeat;
    background-size: 100% 100%;
    margin-right: 8px;
  }
  .hotline {
    text-align: center;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #2d2e33;
    line-height: 17px;
    padding-bottom: 30px;
  }
}
</style>
